module.exports = __webpack_public_path__ + "img/close-black.50128761.svg";